<template>
  <div v-if="item">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7" v-if="item && item.site">
              [{{item.site.name}}] - {{item.site.fqdn}}
            </div>
            <div class="mb7">
              <span class="float-right" v-show="item.finished_at">{{item.created_at | datetime }} ~ {{item.finished_at  ? item.finished_at : '~' | datetime}}</span>
            </div>
          </div>
          <hr>
          <b-row>
            <b-col md="3">
              <b-form-group>
                <label for="ph_count" style="border-bottom: 2px solid;" v-b-tooltip.hover>Site Pages</label><br>
                <label for="ph_page">{{item.page_count }} Numbers</label>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label for="ph_count" style="border-bottom: 2px solid;" v-b-tooltip.hover>External Pages</label><br>
                <label for="ph_ext">{{item.ext_count}} Numbers</label>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label for="ph_count" style="border-bottom: 2px solid;" v-b-tooltip.hover>Detect Pages</label><br>
                <label for="ph_detect">{{item.detect_count}} Numbers</label>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label for="ph_count" style="border-bottom: 2px solid;" v-b-tooltip.hover>Resource Pages</label><br>
                <label for="ph_detect">{{item.resource_count}} Numbers</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>ScreenShot</label><br>
                <a><img class="border" :src="image" :style="{ width: thumbnail_size }"></a>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              Page List
            </div>
            <div class="mb7">
               <small>List of Pages {{item.page_count || 0 | number}} Numbers ({{result.page.start+(item.page_count ? 1 : 0)}} ~ {{result.page.end | number}})</small>
            </div>
          </div>
          <hr>
          <b-row>
            <b-col md="12">
              <pre v-if="item.page_count === 0"><template><div>No Data</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll_page" ref="page_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.page.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              External Page
            </div>
            <div class="mb7">
              <small>List of external site visits {{item.ext_count|number}} Number ({{result.ext.start+(item.ext_count ? 1 : 0)}} ~ {{result.ext.end | number}})</small>
            </div>
          </div>
          <hr>
          <b-row>
            <b-col md="12">
              <pre v-if="item.ext_count === 0 || result.ext.data == ''">
                <template><div>No Data</div></template>
              </pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll_ext" ref="ext_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.ext.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              Resource Data
            </div>
            <div class="mb7">
              <small>Resource Data List {{item.resource_count|number}} Numbers ({{result.resource.start+(item.resource_count ? +1 : 0)}} ~ {{result.resource.end | number}})</small>
            </div>
          </div>
          <hr>
          <b-row>
            <b-col md="12">
              <pre v-if="item.resoure_count === 0 || result.resource.data == ''">
                <template><div>No Data</div></template>
              </pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll_resource" ref="resource_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.resource.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              Detect List
            </div>
            <div class="mb7">
              <small>Detect Pattern List {{item.detect_count|number}} Numbers ({{result.detect.start+(item.detect_count ? 1: 0)}} ~ {{result.detect.end | number}})</small>
            </div>
          </div>
          <hr>
          <b-row>
            <b-col md="12">
              <pre v-if="item.detect_count === 0"><template><div>No Data</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll_detect" ref="detect_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.detect.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>